import { render } from "./AchivementGroup.vue?vue&type=template&id=319d2c3e&scoped=true"
import script from "./AchivementGroup.vue?vue&type=script&lang=js"
export * from "./AchivementGroup.vue?vue&type=script&lang=js"

import "./AchivementGroup.vue?vue&type=style&index=0&id=319d2c3e&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319d2c3e"]])

export default __exports__